function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBalance(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M9.93 18.958V8.042c0-1.243-1.44-2.25-3.216-2.25-1.775 0-3.213 1.007-3.213 2.25v10.916",
    stroke: props.fillSecondary
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M6.715 21.209c1.775 0 3.214-1.008 3.214-2.25 0-1.244-1.439-2.251-3.214-2.251-1.776 0-3.215 1.008-3.215 2.25 0 1.243 1.44 2.25 3.215 2.25z",
    stroke: props.fillSecondary
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M9.68 7.542h12.566A1.253 1.253 0 0123.5 8.796v11.131a1.254 1.254 0 01-1.254 1.254H7.107",
    stroke: props.fillSecondary
  }));
}

export default SvgBalance;